
export const enums = state => state.quartz.enums;

export const changes = state => state.quartz.changes;

export const environments = state => state.quartz.environments;

export const activeKey = state => state.quartz.activeKey;

export const expandedJob = state => state.quartz.expandedJob;

export const serverValues = state => state.quartz.serverValues;

export const infoMessage = state => state.quartz.infoMessage;

export const loading = state => state.quartz.loading;

export const loaded = state => state.quartz.loaded;

export const environmentJobTriggers = (environmentName = '', jobName = '') => state => {
    const envi = environments(state).find(envi => envi.environmentName === environmentName);
    if (envi == null) {
        return null;
    }

    const job = envi.jobs.find(job => job.jobName === jobName);
    return getJobOrNull(job);
};

const getJobOrNull = job => {
    if (job == null ) {
        return null;
    }

    return job;
};
